const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const PLAYLIST_ID_PATTERN = /^[A-Za-z0-9_-]{10,}$/;

export function isHttpUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function extractYouTubeVideoId(value: string): string | null {
  const input = value.trim();
  if (YOUTUBE_ID_PATTERN.test(input)) return input;

  try {
    const url = new URL(input);
    const hostname = url.hostname.replace(/^www\./, "");

    if (hostname === "youtu.be") {
      const id = url.pathname.split("/").filter(Boolean)[0] ?? "";
      return YOUTUBE_ID_PATTERN.test(id) ? id : null;
    }

    if (hostname === "youtube.com" || hostname.endsWith(".youtube.com")) {
      const queryId = url.searchParams.get("v") ?? "";
      if (YOUTUBE_ID_PATTERN.test(queryId)) return queryId;

      const segments = url.pathname.split("/").filter(Boolean);
      if (["embed", "shorts", "live"].includes(segments[0] ?? "")) {
        const id = segments[1] ?? "";
        return YOUTUBE_ID_PATTERN.test(id) ? id : null;
      }
    }
  } catch {
    return null;
  }

  return null;
}

export function extractYouTubePlaylistId(value: string): string | null {
  const input = value.trim();
  if (PLAYLIST_ID_PATTERN.test(input) && !input.includes(".")) return input;

  try {
    const url = new URL(input);
    const id = url.searchParams.get("list") ?? "";
    return PLAYLIST_ID_PATTERN.test(id) ? id : null;
  } catch {
    return null;
  }
}

export function canonicalYouTubeUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function inferTitleFromUrl(value: string, index: number): string {
  try {
    const url = new URL(value);
    const pathName = decodeURIComponent(url.pathname.split("/").filter(Boolean).at(-1) ?? "");
    const usefulPath = pathName.replace(/[-_]+/g, " ").replace(/\.[a-z0-9]{2,5}$/i, "").trim();
    return usefulPath || url.hostname.replace(/^www\./, "") || `Video ${index + 1}`;
  } catch {
    return `Video ${index + 1}`;
  }
}
